"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargingSessionMatchingPatternValidation = void 0;
class ChargingSessionMatchingPatternValidation {
    static isValid(enumValue) {
        if (typeof enumValue !== "number")
            return false;
        if (!(0 <= enumValue && enumValue <= 4)) {
            return false;
        }
        return true;
    }
}
exports.ChargingSessionMatchingPatternValidation = ChargingSessionMatchingPatternValidation;
